import apiPath from '../../../config/api';

const SalesPath = {
    title: "Permata - Modul Penjualan",
    basePath: "/permata/penjualan",
    newPath: "/permata/penjualan/baru",
    detailPath: "/permata/penjualan/opsi/:id",
    base: apiPath.retailSales,
    baseHistory: apiPath.retailSalesHistory,
    salesExcel: apiPath.retailSalesExcel,
    custFind: apiPath.masterCustFind,
    gnsFind: apiPath.masterGnsFind,
    paymentMethodFind: apiPath.masterPaymentFind,
}

export default SalesPath;
